/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkerUpdate
 */
export interface MarkerUpdate {
    /**
     * 
     * @type {string}
     * @memberof MarkerUpdate
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MarkerUpdate
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof MarkerUpdate
     */
    tIn: number;
    /**
     * 
     * @type {number}
     * @memberof MarkerUpdate
     */
    tOut: number;
    /**
     * 
     * @type {number}
     * @memberof MarkerUpdate
     */
    asset: number;
}

export function MarkerUpdateFromJSON(json: any): MarkerUpdate {
    return MarkerUpdateFromJSONTyped(json, false);
}

export function MarkerUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkerUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'tIn': json['t_in'],
        'tOut': json['t_out'],
        'asset': json['asset'],
    };
}

export function MarkerUpdateToJSON(value?: MarkerUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'text': value.text,
        't_in': value.tIn,
        't_out': value.tOut,
        'asset': value.asset,
    };
}


